export default __webpack_public_path__ + "ed0c88a223813354130aafcbfdf6ade3.svg";